import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'drafts',
  initialState: {
    activeDraftId: undefined,
    draftListObject: {},
    from: '',
    defaultFrom: 'me',
    type: 'standalone',
    isNew: false,
    temporalDraftValues: {
    },
    isCreating: false,
  },
  reducers: {
    setIsCreating: (state, action) => {
      state.isCreating = action.payload
    },
    setActiveDraft: (state, action) => {
      state.activeDraftId = action.payload
    },
    setValueOfActiveDraft: (state, action) => {
      const payload = action.payload
      const draft = state.draftListObject[state.activeDraftId]
      draft[payload.field] = payload.value
      state.draftListObject[state.activeDraftId] = draft
    },
    setValuesOfActiveDraftOnList: (state, action) => {
      const payload = action.payload
      let draft = state.draftListObject[state.activeDraftId]
      draft = Object.assign(draft, payload)
      state.draftListObject[state.activeDraftId] = draft
    },
    setTemporalDraftBufferValues: (state, action) => {
      const payload = action.payload
      state.temporalDraftValues = Object.assign(state.temporalDraftValues, payload)
    },
    unSetTemporalDraftBufferValues: (state) => {
      state.temporalDraftValues = {}
    },
    unMarkActiveDraftId: (state) => {
      state.activeDraftId = ''
    },
    setMessageSent: (state) => {
      state.sent = true
    },
    addChoice: (state, action) => {
      const choice = action.payload
      state.choices = [...state.choices, choice]
    },
    removeChoice: (state, action) => {
      const choice = action.payload
      state.choices = state
        .choices
        .filter(
          (filteredChoice) => filteredChoice.id !== choice.id
        )
    },
    addAttachment: (state, action) => {
      const file = action.payload
      state.attachments.push(file)
    },
    deleteAttachment: (state, action) => {
      const attachmentId = action.payload
      state.attachments = state.attachments.filter((attachment) => attachment.id !== attachmentId)
    },
    setDraft: (state, action) => {
      const draft = action.payload
      state.id = draft.messagedraftid
      state.from = draft.boxname || state.defaultFrom
      state.tos = draft.tos
      state.ccs = draft.ccs
      state.bccs = draft.bccs
      state.messageHTML = draft.html
      state.messageText = draft.plain
      state.subject = draft.subject || ' '
      state.slateContent = draft.slatecontent
      state.attachments = draft.attachmentdrafts?.map(attachment => ({
        name: attachment.filename,
        id: attachment.composedid,
        messagedraftid: attachment.messagedraftid,
        mimetype: attachment.mimetype,
        uri: attachment.uri,
      }))
      state.createdAt = draft.createdAt
      state.updatedAt = draft.updatedAt
    },
    resetAllFieldsOfDraft: (state) => {
      const draft = state.draftListObject[state.activeDraftId]
      if (!draft) {
        return
      }
      draft.tos = []
      draft.ccs = []
      draft.bccs = []
      draft.from = ''
      draft.subject = ''
      draft.messageText = ''
      draft.messageHTML = ''
      draft.id = ''
      draft.slateContent = [
        {
          type: 'paragraph',
          children: [
            { text: '' }
          ],
        }
      ]
      draft.tosDirty = undefined
      draft.attachments = []
      state.draftListObject[state.activeDraftId] = draft
      state.activeDraftId = undefined
      state.temporalDraftValues = {}
      state.type = 'standalone'
    },
    removeToAddress: (state, action) => {
      const addressValue = action.payload
      state.tos = state.tos.filter(address => address !== addressValue)
    },
    addDraftListObject: (state, action) => {
      const drafts = action.payload
      state.draftListObject = {
        ...state.draftListObject, ...drafts
      }
    },
    removeDraftMessageByMessageId: (state, action) => {
      const messageId = action.payload
      delete state.draftListObject[messageId]
    },
    setDraftMessageType: (state, action) => {
      const type = action.payload
      state.type = type
    },
  },
})

export const {
  setMessageSent, addToAddress,
  setActiveDraft, addDraftListObject,
  setDraft, setSlateContent,
  removeToAddress, resetAllFieldsOfDraft,
  setFrom, removeChoice, addChoice, setDefaultFrom,
  removeDraftMessageByMessageId,
  addAttachment, deleteAttachment, setDraftId,
  addDraftList, setValueOfActiveDraft, setDraftMessageType,
  setValuesOfActiveDraftOnList,
  setTemporalDraftBufferValues,
  unMarkActiveDraftId,
  unSetTemporalDraftBufferValues
} = slice.actions

export default slice.reducer
